import * as Sentry from '@sentry/react';
import { Alert } from 'react-bootstrap';
import * as texts from 'src/common/resources/texts';
import Toaster from '@components/toaster/Toaster';
import { createContext, ReactNode, useMemo, useState } from 'react';
import { IToaster, IToasterContext } from '@interfaces/toaster';

export const ToasterContext = createContext<IToasterContext | null>(null);

const defaultToaster: IToaster = {
  headerText: '',
  message: '',
  background: 'success',
};

const ToasterProvider = ({ children }: { children: ReactNode }) => {
  const [show, setShow] = useState(false);
  const [toaster, setToaster] = useState<IToaster>(defaultToaster);
  
  const showToaster = (toaster: IToaster) => {
    setShow(true);
    setToaster(toaster);
  };

  const contextValue = useMemo(
    () => ({
      toaster,
      showToaster,
    }),
    [toaster],
  );

  return (
    <ToasterContext.Provider value={contextValue}>
      <Toaster
        show={show}
        bg={toaster.background}
        message={toaster.message}
        handleClose={() => setShow(false)}
        headerText={toaster.headerText}
      />
      {children}
    </ToasterContext.Provider>
  );
};

export default Sentry.withErrorBoundary(ToasterProvider, {
  fallback: <Alert variant="danger">{texts.UNEXPECTED_ERROR}</Alert>,
});
